import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const AngleLeftIcon = ({ size, color, deg, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1900 1900", size: size, color: color, deg: deg },
    React.createElement("path", { d: "M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z" })));
export const AngleLeft = iconGenerator(AngleLeftIcon);
//# sourceMappingURL=AngleLeft.js.map